import React from 'react';

const LeadsStatusesFetchContext = React.createContext({});
LeadsStatusesFetchContext.displayName = 'LeadsStatusesFetchContext';

export default LeadsStatusesFetchContext;
